import { render, staticRenderFns } from "./Volunteer.vue?vue&type=template&id=27bb4834&scoped=true"
import script from "./Volunteer.vue?vue&type=script&lang=js"
export * from "./Volunteer.vue?vue&type=script&lang=js"
import style0 from "./Volunteer.vue?vue&type=style&index=0&id=27bb4834&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb4834",
  null
  
)

export default component.exports